module.exports = __webpack_public_path__ + "static/img/case_02.fa72a24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case_02.jpg
// module id = u9iX
// module chunks = 0